export function initialState() {
  return {
    color: {
      hex: '#000000',
    },
    drawingMode: false,
    lineWidth: 1,
    wavy: false,
    dashed: false,
    opacity: 0.3,
    export: '',
    image: '',
    activeObject: null,
    players: [],
    homeModuleUsedPlayerIds: [],
    homeModule2UsedPlayerIds: [],
    opponentModuleUsedPlayerIds: [],
    kickUsedPlayerIds: [],
    usedPlayerKey: null,
    moduleKey: null,
    kickIndex: null,
    backgrounds: [],
    objects: [],
  };
}

export default {
  ...initialState(),
};



// WEBPACK FOOTER //
// ./src/store/matches-editor/state.js